/* Color Variant Thumbs v1 – max 4 visible, Pfeile nur bei >4, stabile Initialisierung */
(() => {
  function setSwatchBackgrounds(root = document) {
    root.querySelectorAll('.color-swatch--with-image').forEach(el => {
      const raw = el.getAttribute('data-variant-image');
      if (!raw) return;
      const url = raw.startsWith('//') ? window.location.protocol + raw : raw;
      Object.assign(el.style, {
        backgroundImage: `url('${url}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      });
    });
  }

  function markHasMany(root = document) {
    root.querySelectorAll('.grid-product__colors, .product-variant-images').forEach(list => {
      let count = 0;
      try {
        count = list.querySelectorAll(':scope > a, :scope > .color-swatch, :scope > .variant-swatch').length;
      } catch (e) {
        count = list.querySelectorAll('a, .color-swatch, .variant-swatch').length;
      }
      list.classList.toggle('has-many', count > 4);
    });
  }

  function removeLegacyArrows(root = document) {
    root.querySelectorAll('.swatch-arrow, .swiper-button-prev, .swiper-button-next')
        .forEach(el => el.remove());
  }

  function init(root = document) {
    setSwatchBackgrounds(root);
    markHasMany(root);
    removeLegacyArrows(root);
  }

  ['DOMContentLoaded','load','pageshow'].forEach(ev =>
    window.addEventListener(ev, () => requestAnimationFrame(() => init()))
  );
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
